import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Admin emails with roles
export const ADMIN_EMAILS = [
  { email: 'arkijp@gmail.com', role: 'master_admin' },
  { email: 'vagiadimara@gmail.com', role: 'admin' },
  { email: 'rafaelericcervantes@gmail.com', role: 'admin' },
  { email: 'talinee.ag@gmail.com', role: 'admin' },
  { email: 'elia.reyes.e@gmail.com', role: 'admin' }
];

export const isAdmin = (email) => {
  return ADMIN_EMAILS.some(admin => admin.email === email);
};

export const isMasterAdmin = (email) => {
  return email === 'arkijp@gmail.com';
};

/**
 * Get auth headers for API calls.
 * Returns Authorization header if a Supabase session is active, otherwise
 * an empty object. There is no fallback.
 */
export async function getAuthHeaders() {
  const headers = {};

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      headers['Authorization'] = `Bearer ${session.access_token}`;
    }
  } catch (err) {
    console.warn('getAuthHeaders: failed to read Supabase session', err);
  }

  return headers;
}

/**
 * Wrapper around fetch() that auto-attaches the Supabase JWT.
 *
 * Behaviour:
 * - Always reads the current Supabase session and adds an
 *   Authorization: Bearer <jwt> header if a session exists.
 * - Preserves any caller-supplied headers; caller headers win
 *   on key collision EXCEPT for Authorization, which apiFetch
 *   always controls.
 * - Does NOT set Content-Type automatically. Caller decides
 *   (JSON callers pass it; multipart/FormData callers omit it
 *   so the browser sets the multipart boundary).
 * - Returns the raw Response object, same as fetch().
 *
 * Usage:
 *   const resp = await apiFetch(url);  // GET, with auth
 *   const resp = await apiFetch(url, {
 *     method: 'POST',
 *     headers: { 'Content-Type': 'application/json' },
 *     body: JSON.stringify(payload),
 *   });
 */
export async function apiFetch(url, options = {}) {
  const authHeaders = await getAuthHeaders();
  const callerHeaders = options.headers || {};
  // Caller headers win, except Authorization which we always control.
  const mergedHeaders = { ...callerHeaders, ...authHeaders };
  return fetch(url, { ...options, headers: mergedHeaders });
}